import standardAPI from '@/api/standard_items';

const state = {
  agency_types: [],
  agency_types_status: '',
  agency_types_MetaData: {},
  agency_types_page: 1,
  agency_types_perPage: 10,
};

const responseUrl = '/agency/types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_agency_types ({ commit }, getOptions) {
    commit('AGENCY_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('AGENCY_TYPES_SUCCESS', response);
            commit('AGENCY_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('AGENCY_TYPES_READY');
            reject(response);
          } else {
            commit('AGENCY_TYPES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_agency_type ({ commit, dispatch }, itemData) {
    commit('AGENCY_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('AGENCY_TYPES_READY');
          resolve(response);
        } else {
          commit('AGENCY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  edit_agency_type ({ commit, dispatch }, itemData) {
    commit('AGENCY_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('AGENCY_TYPES_READY');
          resolve(response);
        } else {
          commit('AGENCY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  remove_agency_type ({ commit, dispatch }, itemData) {
    commit('AGENCY_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('AGENCY_TYPES_READY');
          resolve(response);
        } else {
          commit('AGENCY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_agency_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.agency_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.agency_types_perPage = max;
  },
  AGENCY_TYPES_READY: (state) => {
    state.agency_types_status = 'ready';
  },
  AGENCY_TYPES_REQUEST: (state) => {
    state.agency_types_status = 'loading';
  },
  AGENCY_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.agency_types_MetaData.meta = response.meta;
      state.agency_types_MetaData.links = response.links;
    }
    state.agency_types = response.data;
    state.agency_types_status = 'success';
  },
  AGENCY_TYPES_ERROR: (state) => {
    state.agency_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
